__turbopack_context__.v({
  "active": "SideBar-module-scss-module__S3BEcq__active",
  "amount": "SideBar-module-scss-module__S3BEcq__amount",
  "avatar": "SideBar-module-scss-module__S3BEcq__avatar",
  "balance-wrapper": "SideBar-module-scss-module__S3BEcq__balance-wrapper",
  "burger-button": "SideBar-module-scss-module__S3BEcq__burger-button",
  "chevron": "SideBar-module-scss-module__S3BEcq__chevron",
  "collapsed": "SideBar-module-scss-module__S3BEcq__collapsed",
  "container": "SideBar-module-scss-module__S3BEcq__container",
  "email": "SideBar-module-scss-module__S3BEcq__email",
  "full-hide": "SideBar-module-scss-module__S3BEcq__full-hide",
  "full-name": "SideBar-module-scss-module__S3BEcq__full-name",
  "header": "SideBar-module-scss-module__S3BEcq__header",
  "icon-wrapper": "SideBar-module-scss-module__S3BEcq__icon-wrapper",
  "image": "SideBar-module-scss-module__S3BEcq__image",
  "link": "SideBar-module-scss-module__S3BEcq__link",
  "links-container": "SideBar-module-scss-module__S3BEcq__links-container",
  "logo": "SideBar-module-scss-module__S3BEcq__logo",
  "logo-container": "SideBar-module-scss-module__S3BEcq__logo-container",
  "logout-buttons": "SideBar-module-scss-module__S3BEcq__logout-buttons",
  "logout-container": "SideBar-module-scss-module__S3BEcq__logout-container",
  "logout-modal-button": "SideBar-module-scss-module__S3BEcq__logout-modal-button",
  "overlay": "SideBar-module-scss-module__S3BEcq__overlay",
  "profile": "SideBar-module-scss-module__S3BEcq__profile",
  "small-balance-wrapper": "SideBar-module-scss-module__S3BEcq__small-balance-wrapper",
  "supress-icon": "SideBar-module-scss-module__S3BEcq__supress-icon",
  "supress-icon-open": "SideBar-module-scss-module__S3BEcq__supress-icon-open",
  "text": "SideBar-module-scss-module__S3BEcq__text",
  "theme-collapsed": "SideBar-module-scss-module__S3BEcq__theme-collapsed",
  "theme-switcher": "SideBar-module-scss-module__S3BEcq__theme-switcher",
});
